/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addlocation1Inputs */

const en_addlocation1 = /** @type {(inputs: Addlocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Location`)
};

const de_addlocation1 = /** @type {(inputs: Addlocation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add Location" |
*
* @param {Addlocation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addlocation1 = /** @type {((inputs?: Addlocation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addlocation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addlocation1(inputs)
	return de_addlocation1(inputs)
});
export { addlocation1 as "addLocation" }